import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Eventi from "./pages/Eventi";
import EventDetail from "./pages/EventDetail";
import Podcast from "./pages/Podcast";
import Tesseramento from "./pages/Tesseramento";
import Corsi from "./pages/Corsi";
import Merchandising from "./pages/Merchandising";
import Contatti from "./pages/Contatti";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

axios.defaults.withCredentials = true;

function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) return;
    const API = process.env.REACT_APP_BACKEND_URL + "/api";
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, "", "/");
        navigate(data.is_admin ? "/admin" : "/", { replace: true, state: { user: data } });
      } catch (e) {
        setError("Autenticazione fallita");
      }
    })();
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-[#000000] text-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-pulse text-2xl font-black uppercase tracking-widest">Flow.Bologna</div>
        <div className="mt-4 text-white/70">{error || "Autenticazione in corso..."}</div>
      </div>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if ((location.hash || "").includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="eventi" element={<Eventi />} />
        <Route path="eventi/:id" element={<EventDetail />} />
        <Route path="podcast" element={<Podcast />} />
        <Route path="tesseramento" element={<Tesseramento />} />
        <Route path="corsi" element={<Corsi />} />
        <Route path="shop" element={<Merchandising />} />
        <Route path="contatti" element={<Contatti />} />
        <Route path="admin" element={<Admin />} />
        <Route path="login" element={<Login />} />
        <Route path="payment/success" element={<PaymentSuccess />} />
        <Route path="payment/cancel" element={<PaymentCancel />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
